import { defineStore } from 'pinia';

import { useHotelSelectionStore } from '../../pages/hotelSelection/stores';
import { useActivitySelectionStore } from '../../pages/activitySelection/stores';
import { useFlightsListModalsStore } from '../../pages/flights/store/flightListModalsStore';
import { useFerryListPanelsStore } from '../../pages/ferry/store/ferryListPanelsStore';

import { useRouterStore } from './routerStore';

export const usePageConnectorStore = defineStore('PageConnectorStore', () => {
  const routerStore = useRouterStore();
  const hotelSelectionStore = useHotelSelectionStore();
  const activitySelectionStore = useActivitySelectionStore();
  const flightsListModalsStore = useFlightsListModalsStore();
  const ferryListPanelsStore = useFerryListPanelsStore();

  async function openHotelSelectionFilters(
    ingredientIndex: number
  ): Promise<void> {
    await routerStore.navigateToHotelSelection({ ingredientIndex });
    hotelSelectionStore.openFilters();
  }

  async function openActivitySelectionFilters(
    ingredientIndex: number
  ): Promise<void> {
    await routerStore.navigateToActivitySelection({ ingredientIndex });
    activitySelectionStore.toggleFilters();
  }

  async function openFlightListFilters(): Promise<void> {
    await routerStore.navigateToFlightsList();
    flightsListModalsStore.openModalFilter();
  }

  async function openFerryListFilters(): Promise<void> {
    await routerStore.navigateToFerryList();
    ferryListPanelsStore.openFiltersPanel();
  }

  return {
    openHotelSelectionFilters,
    openActivitySelectionFilters,
    openFlightListFilters,
    openFerryListFilters,
  };
});
